/**
 * App-level entry for product tours: mounted once from `App`. Defers rendering until Auth0 and
 * onboarding storage (`useProductOnboarding`) are ready; all tour logic lives in `useProductTourJoyride`.
 */
import { GUIDED_TOUR_ENABLED } from '../../../constants/featureFlags';
import { useProductTourJoyride } from './useProductTourJoyride';

export const ProductOnboardingManager = () => {
  if (!GUIDED_TOUR_ENABLED) {
    return null;
  }
  return <ProductOnboardingManagerInner />;
};

const ProductOnboardingManagerInner = () => {
  const { ui, overlayReady } = useProductTourJoyride();

  if (!overlayReady) {
    return null;
  }

  return ui;
};
